// copy values from .env to window.config (if they exist)
if (import.meta.env.VITE_REMOTE_URL) window.config.front_url = import.meta.env.VITE_REMOTE_URL;
if (import.meta.env.VITE_TENANT_ID) window.config.clientId = import.meta.env.VITE_TENANT_ID;
if (import.meta.env.VITE_SITE_ID) window.config.siteId = import.meta.env.VITE_SITE_ID;
if (import.meta.env.VITE_BLOG_API_URL) window.config.blogApiUrl = import.meta.env.VITE_BLOG_API_URL;
if (import.meta.env.VITE_BLOG_API_TOKEN) window.config.blogApiToken = import.meta.env.VITE_BLOG_API_TOKEN;
if (import.meta.env.VITE_BLOG_TENANT_ID) window.config.blogTenantId = import.meta.env.VITE_BLOG_TENANT_ID;
if (import.meta.env.VITE_ESIGN_API_URL) window.config.esignApiUrl = import.meta.env.VITE_ESIGN_API_URL;
if (import.meta.env.VITE_CREATIVES_API_URL) window.config.creativesApiUrl = import.meta.env.VITE_CREATIVES_API_URL;
if (import.meta.env.VITE_CREATIVES_PREVIEW_BASE_URL)
  window.config.creativesPreviewBaseUrl = import.meta.env.VITE_CREATIVES_PREVIEW_BASE_URL;
if (import.meta.env.VITE_OWS_MAIL_API_URL) window.config.owsMailApiUrl = import.meta.env.VITE_OWS_MAIL_API_URL;
if (import.meta.env.VITE_UXO_EVENTS_URL) window.config.uxoEventsUrl = import.meta.env.VITE_UXO_EVENTS_URL;
if (import.meta.env.VITE_MAILBOX_FIXTURES === 'true') window.config.mailboxFixtures = true;

if (import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS) window.config.enableLocalJackpots = import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS === 'true' ? '1' : '';

if (import.meta.env.VITE_APP_PLATFORM) {
  if (import.meta.env.VITE_LOADER_URL) window.config.loaderImage = import.meta.env.VITE_LOADER_URL;
  if (import.meta.env.VITE_LOADER_TEXT) window.config.loaderText = import.meta.env.VITE_LOADER_TEXT;

  window.config.cordova = true;
  window.config.native_platform = import.meta.env.VITE_APP_PLATFORM;
}

if (import.meta.env.VITE_DEFAULT_LANGUAGE) window.config.defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE;

//DO NOT REMOVE - This is related to the popup switch
// check if newsite cookie is set
if (!document.cookie.includes('newsite=yes; expires')) {
  // get domain without www and subdomains
  // let domain = window.location.hostname.replace('www.', '');
  // domain = domain.split('.');
  // domain = domain[domain.length - 2] + '.' + domain[domain.length - 1];
  document.cookie = 'newsite=yes; expires=Tue, 01 Jan 2069 12:00:00 UTC;path=/';
}

const removeMeta = () => {
  try {
    document.querySelector('head>title').remove();
  } catch (e) { }

  const metas = [
    'description',
    'og:description',
    'twitter:description',
    'keywords',
    'og:keywords',
    'twitter:keywords',
    'og:site_name',
    'twitter:site',
    'twitter:creator',
    'og:image',
    'twitter:image',
    'og:image:width',
    'og:image:height',
    'og:image:alt',
    'twitter:image:alt',
    'og:type',
    'og:locale',
    'og:locale:alternate',
    'og:video',
    'og:video:width',
    'og:video:height',
    'og:video:type',
    'og:video:alt',
    'twitter:card',
    'thumbnail',
    'og:title',
  ];

  metas.forEach((meta) => {
    try {
      document.querySelector(`meta[property="${meta}"]`).remove();
    } catch (e) { }
  });

  const links = ['canonical', 'og:url', 'twitter:url'];

  links.forEach((meta) => {
    try {
      document.querySelector(`link[rel="${meta}"]`).remove();
    } catch (e) { }
  });
};
removeMeta();

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('appEnv') && urlParams.get('appEnv') === 'flutter') { // mobile app
  window.config.appEnv = 'flutter'; // used in tmpls: eko-mobile-page-header, mobile-page-header
  window.config.disableCookies = '1';
  document.documentElement.classList.add('flutter');

  if (urlParams.has('platformType')) {
    const platformType = urlParams.get('platformType');
    if (['1', '2', '3', '4', '5'].includes(platformType)) {
      window.config.platformType = platformType;
    }
  }
}

if (urlParams.has('appEnv') && urlParams.get('appEnv') === 'wrapper-mobile') { // generic mobile app
  window.config.appEnv = 'wrapper-mobile';
  document.documentElement.classList.add('wrapper-mobile');

  if (urlParams.has('disableCookiesAgreement')) {
    window.config.disableCookies = '1';
  }

  if (urlParams.has('platformType')) {
    const platformType = urlParams.get('platformType');
    if (['1', '2', '3', '4', '5'].includes(platformType)) {
      window.config.platformType = platformType;
    }
  }
}

if (urlParams.has('SourceSubBrand') && urlParams.get('SourceSubBrand') === '168') { // poker app
  window.config.appEnv = 'poker';
  window.config.disableCookies = '1';
  document.documentElement.classList.add('poker');

  localStorage.removeItem('access_token');
  localStorage.removeItem('token_type');
  localStorage.removeItem('auth_type');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('auth_date');

  if (urlParams.has('SourceProductPackage')) {
    let platformType = urlParams.get('SourceProductPackage');
    if (['6', '41', '122', '126'].includes(platformType)) {
      switch (platformType) {
        case '6':
        case '41':
          platformType = '1';
          break;
        case '122':
          platformType = '3';
          break;
        case '126':
          platformType = '4';
          break;
      }

      window.config.platformType = platformType;
    }
  }
}

if (window.config.appEnv === 'flutter' || window.config.appEnv === 'poker') {
  let originalHeight = document.scrollingElement.scrollHeight;
  window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');

  const resizeObserver = () => {
    if (originalHeight === document.scrollingElement.scrollHeight) return;
    //console.log('Body height changed:', document.scrollingElement.scrollHeight);

    originalHeight = document.scrollingElement.scrollHeight;
    window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');
  };

  setInterval(resizeObserver, 1000);
}

const getLanguageCode = (lang) => {
  if (window.config.appEnv === 'poker') {
    const langs = {
      'ENG': 'en',
      'RUM': 'ro',
    };
    lang = langs[lang];
  }

  // Marketing / backend WIRE codes -> the app's Intl-safe i18n codes (e.g. `br` -> `bra`).
  // MIRRORS BACKEND_TO_APP / toAppLang in src/nova/config/langCodeMap.ts; dev.js is plain JS and
  // cannot import it, so keep the two in sync. (`za` already IS the app code, so it passes through.)
  if (lang) lang = { br: 'bra', ar: 'arg', af: 'za' }[lang] || lang;

  if (lang && Array.isArray(window.config.languages) && window.config.languages.includes(lang)) {
    return lang;
  } else {
    return false;
  }
};

const languageParams = ['lng', 'lang', 'LangID'];

let directLanguageApplied = false;
for (const lang in languageParams) {
  if (urlParams.has(languageParams[lang])) {
    let lng = getLanguageCode(urlParams.get(languageParams[lang]));
    if (lng) {
      try {
        window.config.defaultLanguage = lng; // this is used in i18next initialization. helps us with force language change
        localStorage.setItem('i18nextLng', lng); // this is used in i18next initialization. helps us with force language change
        directLanguageApplied = true;
        break; // exit loop if language is set
      } catch (e) {
      }
    }
  }
}

// New owners arrive from an external marketing site carrying a base64-encoded
// `startProperties` object (locale + tracking consent). Two things happen at boot, before
// i18next initialises and before the auth gate can redirect an unauthenticated arrival:
//   1. Stash the RAW param in sessionStorage so the configurator can still consume it after
//      the auth gate bounces to /login (that redirect drops the query string). The decode +
//      validate + apply lives in the app (nova/pages/configurator-v3/lib/startProperties).
//   2. Pre-seed the UI language from its `locale` (same mechanism as the ?lng= params above),
//      so the FIRST screen — often /login or /register — already renders in the owner's
//      language. A direct ?lng= param still wins (checked via directLanguageApplied).
if (urlParams.has('startProperties')) {
  const rawStartProperties = urlParams.get('startProperties');
  // Cap the stash: spec §5.3 recommends rejecting a raw value over ~16 KB before decoding; ignore a
  // giant (hostile) value rather than copy it into sessionStorage on every load. Mirrors
  // MAX_RAW_LENGTH in src/nova/pages/configurator-v3/lib/startProperties.ts + src/utils/start-tracking.ts.
  if (rawStartProperties && rawStartProperties.length <= 16 * 1024) {
    try {
      sessionStorage.setItem('ows-start-properties', rawStartProperties);
    } catch (e) {
      /* sessionStorage unavailable — the app still reads the param from the URL when present */
    }
    try {
      // Tolerant UTF-8 base64 decode (standard + URL-safe, padding-optional). URLSearchParams
      // turns a base64 '+' into a space, so restore it alongside the URL-safe '-'/'_'. MIRRORS
      // decodeBase64Utf8 in src/nova/pages/configurator-v3/lib/startProperties.ts (plain JS
      // can't import it) — keep both in sync.
      let b64 = rawStartProperties.replace(/ /g, '+').replace(/-/g, '+').replace(/_/g, '/');
      const pad = b64.length % 4;
      if (pad) b64 += '='.repeat(4 - pad);
      const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
      const props = JSON.parse(new TextDecoder().decode(bytes));
      // The hand-off comes from an EXTERNAL site, so every field is untrusted. Accept only
      // tightly-bounded ASCII allowlists and DROP anything else, so a hostile value can't smuggle
      // an injection payload (markup, quotes, entities, path traversal, control/unicode tricks)
      // into sessionStorage/localStorage or a later sink. Patterns MIRROR isSafeLocale/isSafePackage
      // in src/nova/pages/configurator-v3/lib/startProperties.ts (+ the flow charset) — keep in sync.
      const isSafeLocale = (v) => v.length <= 35 && /^[A-Za-z]{2,3}(?:[-_][A-Za-z0-9]{2,8})*$/.test(v);
      const isSafePackage = (v) => /^[A-Za-z0-9][A-Za-z0-9 _-]{0,39}$/.test(v);
      const isSafeVoucher = (v) => /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(v);
      const isSafeFlow = (v) => /^[A-Za-z0-9_-]{1,20}$/.test(v);
      const rawFlow = props && typeof props.flow === 'string' ? props.flow.trim() : '';
      if (rawFlow && isSafeFlow(rawFlow)) {
        // Pre-extract the configurator flow id so the post-auth routing decision (root redirect /
        // register / login) can pick the flow even after the auth-gate /login redirect drops the
        // query string. Read by resolveConfiguratorFlow() in src/utils/configurator-flow.ts
        // (key mirrors START_FLOW_KEY). The resolver also re-decodes the raw param as a fallback.
        try {
          sessionStorage.setItem('ows-start-flow', rawFlow);
        } catch (e) {
          /* sessionStorage unavailable — the resolver still decodes the raw param (best effort) */
        }
      }
      const rawPackage = props && typeof props.selected_package === 'string' ? props.selected_package.trim() : '';
      if (rawPackage && isSafePackage(rawPackage)) {
        // Pre-extract the pack to pre-select so the configurator store can apply it even after
        // the auth-gate /login redirect drops the query string and the raw stash is consumed.
        // Read by readStartSelectedPackage() in the configurator's lib/startProperties.ts
        // (key mirrors START_SELECTED_PACKAGE_KEY). One-shot: the store clears it once applied.
        try {
          sessionStorage.setItem('ows-start-selected-package', rawPackage);
        } catch (e) {
          /* sessionStorage unavailable — the pre-select is best-effort only */
        }
      }
      const rawVoucher = props && typeof props.voucher_code === 'string' ? props.voucher_code.trim() : '';
      if (rawVoucher && isSafeVoucher(rawVoucher)) {
        // Pre-extract the voucher / promo code so the configurator store can seed it onto the
        // session even after the auth-gate /login redirect drops the query string and the raw
        // stash is consumed. Read by readStartVoucherCode() in the configurator's
        // lib/startProperties.ts (key mirrors START_VOUCHER_CODE_KEY). One-shot: the store clears
        // it once the voucher is persisted onto the session.
        try {
          sessionStorage.setItem('ows-start-voucher-code', rawVoucher);
        } catch (e) {
          /* sessionStorage unavailable; the voucher hand-off is best-effort only */
        }
      }
      const rawLocale = props && typeof props.locale === 'string' ? props.locale.trim() : '';
      if (rawLocale && isSafeLocale(rawLocale)) {
        // Resolve the hand-off WIRE code to the app's i18n code (e.g. `br` -> `bra`) up front, so
        // BOTH the override flag and the pre-seed below use the code the app actually recognises.
        const appLocale = getLanguageCode(rawLocale);
        // Flag the hand-off locale so the app-wide saved-language adoption (nova/theme/OwsTheme)
        // doesn't revert it, and so regionForLocale() gets a code it knows. Key mirrors
        // START_LOCALE_OVERRIDE_KEY. Fall back to the raw code for an unsupported hand-off.
        try {
          sessionStorage.setItem('ows-start-locale-override', appLocale || rawLocale);
        } catch (e) {
          /* sessionStorage unavailable — OwsTheme just won't suppress adoption (best effort) */
        }
        // Pre-seed i18next so the FIRST screen (often /login or /register) renders in the owner's
        // language — unless a direct ?lng= already won above.
        if (!directLanguageApplied && appLocale) {
          window.config.defaultLanguage = appLocale;
          localStorage.setItem('i18nextLng', appLocale);
        }
      }
      // Pre-extract the MARKET hand-off (operating region + currency + campaign tracking ids)
      // into durable per-field keys so they survive the auth-gate /login redirect (which drops
      // the query string) AND the one-shot raw-`startProperties` stash being consumed by the
      // configurator. Read by readStartMarketHandoff() in src/utils/start-properties-market.ts
      // (keys mirror START_OR_KEY/START_CURRENCY_KEY/START_CPID_KEY/START_CID_KEY): the session
      // mint forwards or/cpid/cid, and the configurator pre-selects the region from `or`. SHAPE
      // guard only (mirrors CODE_RE in start-properties-market.ts): any 3-letter uppercase
      // region/currency code flows through — the backend + `/configurator` catalogue are the
      // authority on which market is active — so a new market (e.g. BRA/BRL) needs no change here.
      // Only malformed/hostile values are dropped (defence-in-depth).
      const isSafeCode = (v) => /^[A-Z]{3}$/.test(v);
      const isGuid = (v) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
      const stashField = (key, value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch (e) {
          /* sessionStorage unavailable — readStartMarketHandoff() re-decodes the raw param */
        }
      };
      const rawOr = props && typeof props.or === 'string' ? props.or.trim().toUpperCase() : '';
      if (isSafeCode(rawOr)) stashField('ows-start-or', rawOr);
      const rawCurrency = props && typeof props.currency === 'string' ? props.currency.trim().toUpperCase() : '';
      if (isSafeCode(rawCurrency)) stashField('ows-start-currency', rawCurrency);
      const rawCpid = props && typeof props.cpid === 'string' ? props.cpid.trim() : '';
      if (isGuid(rawCpid)) stashField('ows-start-cpid', rawCpid);
      const rawCid = props && typeof props.cid === 'string' ? props.cid.trim() : '';
      if (isGuid(rawCid)) stashField('ows-start-cid', rawCid);
      // Pre-extract the TEMPLATE hand-off (a marketing-site pre-picked design: seed / skin / art
      // style ids from the public configurator catalogue) into durable per-field keys so the
      // configurator can pre-select + persist the design even after the auth-gate /login redirect
      // drops the query string and the raw stash is consumed. Read by readStartTemplate() in each
      // flow's lib/startProperties.ts (keys mirror START_TEMPLATE_SEED_KEY/SKIN_KEY/ART_STYLE_KEY).
      // One-shot: the configurator store clears them once the design is seeded. IDs are bounded
      // positive integers — this MIRRORS toCatalogId in lib/startProperties.ts EXACTLY (same
      // number/numeric-string acceptance and the same 999,999,999 ceiling), so a value stashed here
      // survives the store's re-read validation (readStartTemplate → toCatalogId) at the boundary.
      const safeId = (v) => {
        const n =
          typeof v === 'number'
            ? v
            : typeof v === 'string' && /^\d{1,9}$/.test(v.trim())
              ? Number(v.trim())
              : NaN;
        return Number.isInteger(n) && n > 0 && n <= 999999999 ? n : null;
      };
      const tpl = props && typeof props.template === 'object' && props.template ? props.template : null;
      if (tpl) {
        const seedId = safeId(tpl.site_seed_id);
        const skinId = safeId(tpl.site_skin_id);
        const artStyleId = safeId(tpl.site_art_style_id);
        if (seedId) stashField('ows-start-template-seed', String(seedId));
        if (skinId) stashField('ows-start-template-skin', String(skinId));
        if (artStyleId) stashField('ows-start-template-art-style', String(artStyleId));
      }
      // Pre-extract the ad-attribution `tracking` object into its OWN durable key so it survives the
      // auth-gate /login redirect (drops the query string), registration, the session mint, reloads,
      // AND the one-shot raw-`startProperties` stash being consumed by the configurator's locale
      // hand-off. Stored RAW (a dumb JSON copy — validation/sanitisation happens app-side in
      // readStartTracking(), src/utils/start-tracking.ts; key mirrors START_TRACKING_KEY); persisted
      // once per account to user-preferences by usePersistStartTracking(). Size-capped like the raw
      // stash. One-shot: cleared after the prefs save lands.
      if (props && typeof props.tracking === 'object' && props.tracking && !Array.isArray(props.tracking)) {
        try {
          const trackingJson = JSON.stringify(props.tracking);
          if (trackingJson && trackingJson.length <= 16 * 1024) {
            stashField('ows-start-tracking', trackingJson);
          }
        } catch (e) {
          /* unserialisable tracking — readStartTracking() falls back to decoding the raw param */
        }
      }
    } catch (e) {
      /* malformed hand-off — ignore; the app falls back to its default language */
    }
  }
}

// A STANDALONE `?voucher_code=` URL param is interpreted the same as `startProperties.voucher_code`,
// and WINS over the embedded one when both are present: this runs AFTER the startProperties block, so
// a valid standalone value overwrites the stash it set (an invalid one is dropped, leaving the
// startProperties voucher intact). Read by readStartVoucherCode() in the configurator's
// lib/startProperties.ts (key mirrors START_VOUCHER_CODE_KEY); the stash survives the auth-gate /login
// redirect that drops the query string. Same allowlist (defence-in-depth) as the embedded field.
if (urlParams.has('voucher_code')) {
  const isSafeVoucher = (v) => /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(v);
  const rawVoucher = (urlParams.get('voucher_code') || '').trim();
  if (rawVoucher && isSafeVoucher(rawVoucher)) {
    try {
      sessionStorage.setItem('ows-start-voucher-code', rawVoucher);
    } catch (e) {
      /* sessionStorage unavailable; the voucher hand-off is best-effort only */
    }
  }
}

const jsonDecodeConfig = () => {
  const toDecode = ['depositSettings', 'withdrawSettings'];
  toDecode.forEach((key) => {
    try {
      if (window?.config?.[key]) {
        window.config[key] = JSON.parse(window.config[key]);
      }
    } catch (e) {
      // do nothing;
    }
  });
};
jsonDecodeConfig();

if (navigator?.userAgent?.includes?.('https://github.com/prerender/prerender')) {
  window.config.disableCookies = '1';
  window.config.inPrerender = true;
}

